import styled from '@emotion/styled';
import { SxProps } from '@mui/material';

export type TileRole = 'link' | 'button';

/**
 * A semantic button wrapper without any styles that can be applied to provide accessibility and the natural behavior of a button (e.g. keyboard interactions)
 */
export const SemanticButton = styled('button')<{ sx?: SxProps; disabled?: boolean }>(({
  sx = {} as any,
  disabled = false,
}) => {
  // revert pointer and hover styles if button is disabled.
  // property itself is propagated to the button but manual styles must be set.
  const disabledStyles = disabled
    ? {
        cursor: 'default',
        pointerEvents: 'none',
      }
    : {};

  return {
    background: 'none',
    color: 'inherit',
    border: 'inherit',
    padding: '0',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    borderRadius: 'inherit',
    ...sx,

    ...disabledStyles,
  };
});
